import { render, staticRenderFns } from "./Trial.vue?vue&type=template&id=61c9b40a&scoped=true&"
import script from "./Trial.vue?vue&type=script&lang=js&"
export * from "./Trial.vue?vue&type=script&lang=js&"
import style0 from "./Trial.vue?vue&type=style&index=0&id=61c9b40a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9b40a",
  null
  
)

export default component.exports